<template>
  <div class style="width: 100%;">
    <div class="contaion custom">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="img-box">
						<i class="iconfont">&#xe626;</i>
          </div>
					<p class="number">{{siteCount}}</p>
          <span class="name">站点数量</span>
        </el-col>
        <el-col :span="5">
          <div class="img-box">
            <i class="iconfont">&#xe625;</i>
          </div>
					<p class="number">{{userCount}}</p>
          <span class="name">员工数量</span>
        </el-col>
        <el-col :span="5">
          <div class="img-box">
            <i class="iconfont">&#xe629;</i>
          </div>
					 <p class="number">{{collectDeviceCount}}</p>
          <span class="name">采集设备</span>
        </el-col>
        <el-col :span="5">
          <div class="img-box">
            <i class="iconfont">&#xe627;</i>
          </div>
					<p class="number">{{controlDeviceCount}}</p>
          <span class="name">控制设备</span>
        </el-col>
        <el-col :span="5">
          <div class="img-box">
            <i class="iconfont">&#xe628;</i>
          </div>
					<p class="number">{{cameraCount}}</p>
          <span class="name">摄像头</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// import { getDeviceCount } from "@/api/dash/device";
export default {
	name: "",
	props:{
		cameraCount:{
			type:Number,
			default:0
		},
		siteCount:{
			type:Number,
			default: 0
		},
		collectDeviceCount:{
			type:Number,
			default: 0
		},
		controlDeviceCount:{
			type:Number,
			default: 0
		},
		userCount:{
			type:Number,
			default: 0
		}
	},
  data() {
    return {
      deviceDate: {
        cameraCount: 0,
        collectDeviceCount: 0,
        controlDeviceCount: 0,
        siteCount: 0,
        userCount: 0,
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getDeviceCount();
  },
  methods: {
    getDeviceCount() {
      getDeviceCount().then((res) => {
        console.log(res);
        this.deviceDate = res.data;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.title {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
  &::before {
    content: "";
    width: 6px;
    height: 26px;
    background-color: #209b9a;
    border-radius: 10px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: middle;
  }
}
.name {
  // width: 35px;
	float: left;
	font-size: 14px;
	color: #fff;
  /* margin-top: 10px; */
  vertical-align: middle;
  margin-left: 10px;
  // margin-top: 8px;
}
.contaion {
  // margin-top: 30px;
  // padding: 0 30px;
	padding-left: 30px;
	color: #fff;
  .img-box {
    width: 60px;
    float: left;
		vertical-align: center;
		.iconfont{
			font-size: 60px;
			color: #a4dcf5;
		}
    // img {
    //   width: 100%;
    // }
  }
}
.el-row p {
  text-align: center;
  color: #fff;
  font-size: 16px;
  margin: 0;
  &.number {
    font-size: 24px;
    margin-bottom: 10px;
    text-indent: -15px;
    padding-right: 20px;
  }
}
</style>
<style>
.custom .el-col-5{
	width: 19.8%;
}
</style>
